import EBookDiscount from '@assets/icons/e-book-discount.svg'
import { Icon } from './Icon'

export const EBookDiscountIcon = Icon(EBookDiscount)
